import { Link } from 'react-router-dom';
import { categories, aboutInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-vidicon-line text-2xl text-accent-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                黄瓜视频
              </span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed">
              记录美好，分享快乐。黄瓜视频致力于为全球用户提供优质短视频内容体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#download" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                  下载App
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                {aboutInfo.contact.email}
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-wechat-line"></i>
                </div>
                {aboutInfo.contact.wechat}
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line"></i>
                </div>
                {aboutInfo.contact.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; 2026 黄瓜视频 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-500 hover:text-accent-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-accent-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-accent-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}